import React from "react";

import { Flex, Text, UnorderedList, ListItem, Image } from "@chakra-ui/react";

import RedictiveAnalytics from "../../assets/undraw_predictive_analytics_kf9n.png";

export default function Idea() {
  return (
    <Flex
      marginBottom="140"
      width="100%" //when i use width="1100" then the image don't automatically crop.
      flexDirection={{ base: "column", md: "row" }}
      justifyContent="space-between"
      alignItems="center"
      height="460px"
      p={14}
      marginTop={{ base: 0, sm: 10 }}>
      <Flex
        mt={{ base: 0, sm: 10 }}
        p={7}
        borderRadius={12}
        backgroundColor="blue.400"
        flexDirection="column">
        <Text color="white" fontWeight="bold" fontSize={21}>
          Business Owners
        </Text>
        <Text fontSize={13} marginTop={3} marginBottom={3}>
          ASK PEOPLE TO HELP YOU:
        </Text>
        <UnorderedList marginLeft="7">
          <ListItem color="white">Create a short video</ListItem>
          <ListItem color="white">Promote your content</ListItem>
          <ListItem color="white">Edit a photo</ListItem>
          <ListItem color="white">Crypto jobs</ListItem>
        </UnorderedList>
        <Text color="white" fontWeight="bold" fontSize={21} marginTop={6}>
          Freelancers
        </Text>
        <Text fontSize={13} marginTop={3} marginBottom={3}>
          WORK YOUR WAY:
        </Text>
        <UnorderedList marginLeft="7">
          <ListItem color="white">Take a survey</ListItem>
          <ListItem color="white">Write an honest review</ListItem>
          <ListItem color="white">Test an app</ListItem>
          <ListItem color="white">Write an article</ListItem>
        </UnorderedList>
      </Flex>
      <Flex>
        <Image
          // height="510"

          // src="https://firebasestorage.googleapis.com/v0/b/testing-fc437.appspot.com/o/undraw_predictive_analytics_kf9n.png?alt=media&token=efe16e17-57d6-49b1-908d-8cef026cbfd1"
          src={RedictiveAnalytics}
          alt="Growth"
        />
      </Flex>
    </Flex>
  );
}
